import {
  FormDropdown,
  FormInput,
  FormTextArea,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import Loader from 'components/shared/Helpers/Loader'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Header, Icon, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { properties, propertiesLoading } = state.properties
  return { properties, propertiesLoading }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class NewText extends React.Component {
  render() {
    const { visible, hide, addText } = this.props // ownProps
    const { handleSubmit, invalid, reset } = this.props // reduxForm
    return (
      visible && (
        <Table.Row verticalAlign="bottom" width={5}>
          <Table.Cell>
            <Header
              as="h3"
              content={I18n.t('admin.productProperties.new_text')}
            />
            <Field
              component={FormTextArea}
              name="newTextDe"
              placeholder={I18n.t('global.please_select')}
              className="german"
              label={I18n.t('navigation.languages.de')}
              validate={[validateRequired]}
            />
          </Table.Cell>
          <Table.Cell className="secondary" width={5}>
            <Field
              component={FormTextArea}
              name="newTextFr"
              placeholder={I18n.t('global.please_select')}
              className="french"
              label={I18n.t('navigation.languages.fr')}
              validate={[validateRequired]}
            />
          </Table.Cell>
          <Table.Cell textAlign="right" width={2}>
            <Icon
              onClick={(event) => {
                event.preventDefault()
                hide()
                reset()
              }}
              link
              size="large"
              {...config.icons.cancel}
            />
            <Icon
              {...{
                disabled: invalid,
                color: invalid ? 'black' : 'green',
                size: 'large',
                link: !invalid,
                onClick: handleSubmit((formValues) => {
                  hide()
                  addText(formValues.newTextDe, formValues.newTextFr)
                  reset()
                }),
                ...config.icons.confirm,
              }}
            />
          </Table.Cell>
        </Table.Row>
      )
    )
  }
}

NewText = reduxForm({ form: 'productPropertyNewText' })(NewText)
NewText = connect(mapStateToProps, mapDispatchToProps)(NewText)

class NewProperty extends React.Component {
  componentWillReceiveProps(newProps) {
    const { propertiesLoading: propertiesLoadingNew } = newProps
    const {
      hide,
      propertiesLoading: propertiesLoadingOld,
      visible,
    } = this.props
    if (visible && propertiesLoadingOld && !propertiesLoadingNew) {
      hide()
    }
  }

  render() {
    const { visible, hide, createProperty } = this.props //ownProps
    const { handleSubmit, invalid, reset } = this.props //reduxForm
    const { propertiesLoading } = this.props //redux
    return (
      visible &&
      (propertiesLoading ? (
        <Table.Row verticalAlign="bottom">
          <Table.Cell colSpan={3}>
            <Loader tiny />
          </Table.Cell>
        </Table.Row>
      ) : (
        <Table.Row verticalAlign="bottom">
          <Table.Cell width={5}>
            <Header
              as="h3"
              content={I18n.t('admin.productProperties.new_property')}
            />
            <Field
              component={FormInput}
              name="newPropertyDe"
              placeholder={I18n.t('global.please_select')}
              label={I18n.t('navigation.languages.de')}
              className="german"
              validate={[validateRequired]}
            />
          </Table.Cell>
          <Table.Cell className="secondary" width={5}>
            <Field
              component={FormInput}
              name="newPropertyFr"
              placeholder={I18n.t('global.please_select')}
              label={I18n.t('navigation.languages.fr')}
              className="french"
              validate={[validateRequired]}
            />
          </Table.Cell>
          <Table.Cell textAlign="right" width={2}>
            <Icon
              onClick={(event) => {
                event.preventDefault()
                hide()
                reset()
              }}
              link
              size="large"
              {...config.icons.cancel}
            />
            <Icon
              {...{
                disabled: invalid,
                color: invalid ? 'black' : 'green',
                size: 'large',
                link: !invalid,
                onClick: handleSubmit((formValues) => {
                  createProperty(
                    formValues.newPropertyDe,
                    formValues.newPropertyFr
                  )
                  reset()
                }),
                ...config.icons.confirm,
              }}
            />
          </Table.Cell>
        </Table.Row>
      ))
    )
  }
}

NewProperty = reduxForm({ form: 'productPropertyNewProperty' })(NewProperty)
NewProperty = connect(mapStateToProps, mapDispatchToProps)(NewProperty)

class ExistingProperty extends React.Component {
  render() {
    const { visible, hide, newProperty } = this.props //ownProps
    const { handleSubmit, invalid, reset } = this.props //reduxForm
    const { properties } = this.props //redux
    const optionsDe = properties
      ? properties.map((property) => ({
          value: property.id,
          text: property.name_de,
        }))
      : []
    const optionsFr = properties
      ? properties.map((property) => ({
          value: property.id,
          text: property.name_fr,
        }))
      : []
    return (
      visible && (
        <Table.Row verticalAlign="bottom">
          <Table.Cell>
            <Header
              as="h3"
              content={I18n.t('admin.productProperties.existing_property')}
            />
            <Field
              component={FormDropdown}
              name="existingProperty"
              options={optionsDe}
              placeholder={I18n.t('navigation.languages.de')}
              className="german"
              label={I18n.t('navigation.languages.de')}
              selection
              search={(options,search) => options.filter(option => option.text.toLowerCase().includes(search.toLowerCase()))}
              noError
            />
          </Table.Cell>
          <Table.Cell className="secondary">
            <Field
              component={FormDropdown}
              name="existingProperty"
              options={optionsFr}
              placeholder={I18n.t('navigation.languages.fr')}
              className="french"
              label={I18n.t('navigation.languages.fr')}
              selection
              search={(options,search) => options.filter(option => option.text.toLowerCase().includes(search.toLowerCase()))}
              noError
            />
          </Table.Cell>
          <Table.Cell textAlign="right">
            <Icon
              onClick={(event) => {
                event.preventDefault()
                hide()
                reset()
              }}
              link
              size="large"
              {...config.icons.cancel}
            />
            <Icon
              {...{
                disabled: invalid,
                color: invalid ? 'black' : 'green',
                size: 'large',
                link: !invalid,
                onClick: handleSubmit((formValues) => {
                  newProperty(formValues.existingProperty)
                  hide()
                  reset()
                }),
                ...config.icons.confirm,
              }}
            />
          </Table.Cell>
        </Table.Row>
      )
    )
  }
}

ExistingProperty = connect(mapStateToProps, mapDispatchToProps)(
  ExistingProperty
)
ExistingProperty = reduxForm({ form: 'productPropertyExistingProperty' })(
  ExistingProperty
)
export { NewText, NewProperty, ExistingProperty }



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductPropertyNewRows.jsx